// PriceSummary.jsx - Fiyat özeti ve süre seçici
import React from 'react';
import { getPriceBreakdown } from '../../utils/newApi';

const PriceSummary = ({ 
  reservationType, 
  startTime, 
  endTime, 
  duration,
  userEmail,
  pricingRules,
  onChangeDuration 
}) => {
  const {
    baseHourlyRate,
    hourlyRate,
    iyteEligible,
    priceMultiplier,
    totalPrice,
  } = getPriceBreakdown(reservationType, duration, userEmail, pricingRules);
  const surchargePerHour = hourlyRate - baseHourlyRate;
  const surchargePercent = Math.round((priceMultiplier - 1) * 100);
  const surchargeLabel = `x${priceMultiplier.toFixed(0)}`;

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-blue-100">
        Süre ve Ücret Bilgisi
      </h3>

      {/* Süre Seçici */}
      <div className="p-4 bg-gray-800/50 rounded-lg border border-gray-700">
        <label className="block text-sm font-semibold text-blue-200 mb-3">
          Rezervasyon Süresi
        </label>
        
        <div className="grid grid-cols-3 gap-3">
          {[1, 2, 3].map((hours) => (
            <div
              key={hours}
              onClick={() => onChangeDuration(hours)}
              className={`
                p-4 rounded-lg text-center cursor-pointer transition-all duration-200
                ${duration === hours
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
                  : 'bg-gray-900/50 text-gray-300 hover:bg-gray-700/50'
                }
              `}
            >
              <div className="text-2xl font-bold">{hours}</div>
              <div className="text-xs opacity-75 mt-1">saat</div>
            </div>
          ))}
        </div>

        <p className="text-xs text-gray-300 mt-3">
          Bir günde maksimum 3 saat rezervasyon yapılabilir
        </p>
      </div>

      {/* Fiyat Detayları */}
      <div className="p-5 bg-gradient-to-br from-blue-900/30 to-purple-900/30 rounded-lg border border-blue-700/50">
        <div className="space-y-3">
          {/* Baz Saatlik Ücret */}
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-200">IYTE Saatlik Ücret:</span>
            <span className="text-blue-200 font-semibold">{baseHourlyRate} TL</span>
          </div>

          {!iyteEligible && (
            <div className="flex justify-between items-center text-sm">
              <span className="text-gray-200">Harici Kullanıcı Çarpanı:</span>
              <span className="text-amber-300 font-semibold">{surchargeLabel} (+{surchargePerHour} TL, %{surchargePercent})</span>
            </div>
          )}

          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-200">Uygulanan Saatlik Ücret:</span>
            <span className="text-blue-200 font-semibold">{hourlyRate} TL</span>
          </div>

          {/* Süre */}
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-200">Süre:</span>
            <span className="text-blue-200 font-semibold">{duration} saat</span>
          </div>

          {/* Rezervasyon Tipi */}
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-200">Tip:</span>
            <span className="text-blue-200 font-semibold">
              {reservationType === 'individual' ? 'Bireysel' : 'Grup'}
            </span>
          </div>

          <div className="border-t border-gray-700 my-2"></div>

          {/* Toplam */}
          <div className="flex justify-between items-center">
            <span className="text-lg font-bold text-blue-100">Toplam Ücret:</span>
            <div className="text-right">
              <div className="text-3xl font-bold text-blue-300">{totalPrice} TL</div>
              <div className="text-xs text-gray-300 mt-1">
                ({hourlyRate} TL × {duration} saat)
              </div>
            </div>
          </div>

          <div className={`rounded-lg px-3 py-2 text-xs ${
            iyteEligible
              ? 'bg-emerald-900/30 border border-emerald-700/50 text-emerald-200'
              : 'bg-amber-900/30 border border-amber-700/50 text-amber-200'
          }`}>
            {iyteEligible
              ? 'IYTE emaili ile giriş yaptığınız için indirimli ücret uygulanır.'
              : 'IYTE emaili ile kayıt olmayan kullanıcılar indirimli ücretten yararlanamaz ve normal ücretin 3 katını öder.'}
          </div>
        </div>
      </div>

      {/* Ödeme Bilgisi */}
      <div className="p-4 bg-purple-900/20 border border-purple-700/50 rounded-lg">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-purple-400 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div className="text-xs text-purple-200">
            <strong>Ödeme:</strong> Rezervasyonu oluşturduktan sonra IBAN numarasına 
            havale yapıp dekont yüklemeniz gerekecektir.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;
